import { AssetDetailAnonymousComponent } from './components/asset-detail-anonymous/asset-detail-anonymous.component';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { HomeComponent } from "./pages/home/home.component";
import { AuthGuardService } from "./services/auth-guard.service";
import { HoatDongComponent } from './components/hoat-dong/hoat-dong.component';
// Import Containers
export const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full"
  },
  {
    path: 'asset-detail-anonymous/:id',
    loadChildren: () => import('./components/asset-detail-anonymous/asset-detail-anonymous.module').then(m => m.AssetDetailAnonymousModule)
  },
  {
    path: 'manage-schedule',
    loadChildren: () => import('./common/manage-schedule/manage-schedule.module').then(m => m.ManageScheduleModule)
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: '', component: DefaultLayoutComponent,
    data: { title: '' }, children: [
      { path: 'home', component: HomeComponent },
      {
        path: 'danh-muc',
        loadChildren: () => import('../app/pages/danh-muc/danh-muc.module').then(m => m.DanhMucModule)
      },
      {
        path: 'bao-cao',
        loadChildren: () => import('../app/pages/bao-cao/bao-cao.module').then(m => m.BaoCaoModule)
      },
      {
        path: 'tai-san',
        loadChildren: () => import('../app/pages/tai-san/tai-san.module').then(m => m.TaiSanModule)
      },
      {
        path: 'quan-ly',
        loadChildren: () => import('../app/pages/quan-ly/quan-ly.module').then(m => m.QuanLyModule)
      },
      {
        path: 'he-thong',
        loadChildren: () => import('../app/pages/system/system.module').then(m => m.SystemModule)
      },
      {
        path: 'kiem-ke',
        loadChildren: () => import('../app/pages/kiem-ke/kiem-ke.module').then(m => m.KiemKeModule)
      },
      {
        path: 'hoat-dong',
        loadChildren: () => import('../app/pages/hoat-dong/hoat-dong.module').then(m => m.HoatDongModule)
      },
      {
        path: 'nguoi-dung',
        loadChildren: () => import('../app/pages/user/user.module').then(m => m.UserModule)
      },
    ], canActivate: [AuthGuardService]
  },
  
  // {
  //   path: 'pos', component: DefaultLayoutPosComponent,
  //   data: { title: '' }, children: [
  //     { path: 'home', component: HomeComponent },
  //     {
  //       path: 'danh-muc',
  //       loadChildren: () => import('../app/components/danh-muc/danh-muc.module').then(m => m.DanhMucModule)
  //     },
     
  //   ], canActivate: [AuthGuardService]
  // }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
